import Vue from 'vue'
import budgetApi from '@/api/budget.api'

const state = {
  budgets: {},
  totals: {}
}


const getters = {
  budgets: (state, getters, rootState) => {
    return state.budgets[rootState.project.currentId] || []
  },

  budgetTotal: (state) => (projectId) => {
    const obj = state.totals[projectId]
    if (obj) {
      return {
        ...obj,
        projectTotalExpenses: obj.projectExpenses + obj.projectMemberExpenses,
        projectTotal: obj.projectIncome - obj.projectExpenses - obj.projectMemberExpenses,
        seasonTotalExpenses: obj.seasonExpenses + obj.seasonMemberExpenses,
        seasonTotal: obj.seasonIncome - obj.seasonExpenses - obj.seasonMemberExpenses,
        budgetTotal: obj.budgetIncome - obj.budgetExpenses
      }
    }
    return {}
  }
}


const actions = {
  async loadBudgets ({ commit, rootState }) {
    const projectId = rootState.project.currentId
    const response = await budgetApi.getBudgets(rootState.tenant.current, projectId)
    commit('SET_BUDGETS', { projectId, budgets: response.data })
  },

  async loadBudgetsByProjectId ({ commit, rootState }, projectId) {
    const response = await budgetApi.getBudgets(rootState.tenant.current, projectId)
    commit('SET_BUDGETS', { projectId, budgets: response.data })
  },

  async loadAndUpdateBudget ({ commit, rootState }, entityData) {
    const response = await budgetApi.getBudgetByProjectIdById(rootState.tenant.current, entityData.projectId, entityData.entityId)
    commit('UPDATE_BUDGET', { projectId: entityData.projectId, budget: response.data })
    return response.data
  },

  async loadBudgetTotal ({ commit, rootState }, projectId) {
    const response = await budgetApi.getTotal(rootState.tenant.current, projectId)
    commit('SET_TOTAL', { projectId, total: response.data })
  },

  async createBudget ({ commit, dispatch, rootState }, budget) {
    const projectId = rootState.project.currentId
    const response = await budgetApi.createBudget(rootState.tenant.current, projectId, budget)
    commit('CREATE_BUDGET', { projectId, budget: response.data })
  },

  async updateBudget ({ commit, dispatch, rootState }, budget) {
    const projectId = rootState.project.currentId
    const response = await budgetApi.updateBudget(rootState.tenant.current, projectId, budget.id, budget)
    commit('UPDATE_BUDGET', { projectId, budget: response.data })
  },

  async deleteBudget ({ commit, rootState }, budgetId) {
    const projectId = rootState.project.currentId
    await budgetApi.deleteBudget(rootState.tenant.current, projectId, budgetId)
    commit('DELETE_BUDGET', { projectId, budgetId })
  }
}


const mutations = {
  SET_BUDGETS (state, { projectId, budgets }) {
    Vue.set(state.budgets, projectId, budgets)
  },

  SET_BUDGET (state, { projectId, id, budget }) {
    const changedBudget = state.budgets[projectId].find(budget => budget.id === id)
    const index = state.budgets[projectId].indexOf(changedBudget)
    if (changedBudget && index) {
      state.budgets[projectId][index] = budget
    }
  },

  SET_TOTAL (state, { projectId, total }) {
    Vue.set(state.totals, projectId, total)
  },

  CREATE_BUDGET (state, { projectId, budget }) {
    if (!state.budgets[projectId]) {
      Vue.set(state.budgets, projectId, [budget])
    } else {
      state.budgets[projectId].push(budget)
    }
  },

  UPDATE_BUDGET (state, { projectId, budget }) {
    const _budget = state.budgets[projectId].find(x => x.id === budget.id)

    _budget.name = budget.name
    _budget.budgetCategoryId = budget.budgetCategoryId
    _budget.quantity = budget.quantity
    _budget.amount = budget.amount
    _budget.total = budget.total
  },

  DELETE_BUDGET (state, { projectId, budgetId }) {
    const i = state.budgets[projectId].findIndex(x => x.id === budgetId)
    state.budgets[projectId].splice(i, 1)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
